export default __webpack_public_path__ + "assets/webhooks-23c1a5545e2659b24a7f9edf57a133a9.svg";